import useRedirectURL from '../hooks/useRedirectURL';

function InstantSearchRedirect() {
  const redirectURL = useRedirectURL();

  if (redirectURL) {
    window.location.replace(redirectURL);
  }

  return null;
}

export default InstantSearchRedirect;
